module.exports = __webpack_public_path__ + "img/logo_placeholder.688f2a77.svg";